import script from "./AutoLogoutWarningModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoLogoutWarningModal.vue?vue&type=script&setup=true&lang=ts"

import "./AutoLogoutWarningModal.vue?vue&type=style&index=0&id=61296ba7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61296ba7"]])

export default __exports__